import { Tooltip } from 'antd'
import { Link } from 'react-router-dom'

const LinkCusstom = ({ noUnderline, ...rest }: any) => {
  const customStyle = noUnderline ? { textDecoration: 'none', ...rest.style } : rest.style
  return (
    <Tooltip
      title={rest.children}
      placement="right"
      //   color={'cyan'}
      mouseEnterDelay={0.8}
    >
      <Link to={rest.to} {...rest} style={customStyle}>
        {rest.children}
      </Link>
    </Tooltip>
  )
}

export default LinkCusstom
